import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { InternalLink } from 'smartsuite-ui';
import { getSystemOrigin } from '../../../shared/hooks/linkHooks';
import DashboardContext from '../../../shared/hooks/dashboardContext';

function getFlightLink(id, linkConfig, systemManifest) {
    const systemOrigin = getSystemOrigin(linkConfig, systemManifest);
    const pathname = linkConfig.pathName;
    const queryParams = `?flight_id=${id}`;
    // systemOrigin = https://localhost/WebClient
    // pathname = /Common.Airport/Query/FlightDetails.aspx
    // queryParams = ?flight_id=493
    return `${systemOrigin}${pathname}${queryParams}`;
}

export default function FlightDetailLink(props) {
    const { systemManifest } = useContext(DashboardContext);

    const id = props.resultRow[props.columnConfig.idDataKey];
    const hasAccess = props.resultRow[props.columnConfig.hasAccessDataKey];

    if (!hasAccess || !id) {
        return <span>{props.children}</span>;
    }

    return (
        <InternalLink
            canViewLink={true}
            href={getFlightLink(
                id,
                props.columnConfig.linkConfig,
                systemManifest
            )}
            openInNewTab={props.openInNewTab}
        >
            {props.children}
        </InternalLink>
    );
}

FlightDetailLink.propTypes = {
    children: PropTypes.node,
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    openInNewTab: PropTypes.bool,
    resultRow: PropTypes.instanceOf(Object),
};

FlightDetailLink.defaultProps = {
    openInNewTab: false,
};
